import { ExtendedWindow } from '../types';

declare let window: ExtendedWindow;

export const getFcmInfo = () => {
  try {
    window.caasclient?.getFcmInfo?.();
    window.webkit?.messageHandlers.getFcmInfo.postMessage?.('');
  } catch (error) {
    console.error('[getFcmInfo] ', error);
  }
};
